import React from "react";
import "../Topo/styles.css";
import minhaImagem from "../img/mpma-hs.png";
import Button from 'react-bootstrap/Button';
import Offcanvas from "react-bootstrap/Offcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";

export function Topo({ handleCloseMobileMenu, handleShowMobileMenu, showMobileMenu, SideBarMenu, modo }) {
  const linkURL = "/";

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-topo p-2">
        <div className="mt-2 text-center me-3">
          <a href={linkURL}>
            <img src={minhaImagem} className="img" alt="logo" />
          </a>
        </div>
        <a className="titulo-app navbar-brand" href={linkURL}>Legislação Interna</a>
        <div className="d-block d-md-none">
          <Button variant="light" onClick={handleShowMobileMenu}>
            <FontAwesomeIcon icon={faBars} />
          </Button>

          <Offcanvas show={showMobileMenu} onHide={handleCloseMobileMenu}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filtros de pesquisa</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {SideBarMenu}
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="ms-auto">
          {(modo === "pesquisa") ? (
            <Button variant="warning" href="/orgaos">
              <span className="d-none d-md-block fs-7 text-uppercase"><FontAwesomeIcon icon={faAnglesRight} /> Ver Legislação por Órgão</span>
              <span className="d-block d-md-none fs-7 text-uppercase"><FontAwesomeIcon icon={faAnglesRight} /> Órgãos</span>
            </Button>
          ) : (
            <Button variant="warning" href="/pesquisa">
              <span className="d-none d-md-block fs-7 text-uppercase"><FontAwesomeIcon icon={faAnglesRight} /> Ir para Pesquisa</span>
              <span className="d-block d-md-none fs-7 text-uppercase"><FontAwesomeIcon icon={faAnglesRight} /> Pesquisa</span>
            </Button>
          )}
        </div>
      </nav>
    </>
  );
}
